import 'core-js/modules/es6.string.iterator';
import 'core-js/modules/es6.array.from';
import _classCallCheck from '/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck';
import _createClass from '/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/createClass';
import _possibleConstructorReturn from '/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf';
import _inherits from '/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/inherits';
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module image/imageupload/imageuploadui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileDialogButtonView from '@ckeditor/ckeditor5-upload/src/ui/filedialogbuttonview';
import imageIcon from '@ckeditor/ckeditor5-core/theme/icons/image.svg';
import { createImageTypeRegExp } from './utils';
/**
 * The image upload button plugin.
 *
 * For a detailed overview, check the {@glink features/image-upload/image-upload Image upload feature} documentation.
 *
 * Adds the `'imageUpload'` button to the {@link module:ui/componentfactory~ComponentFactory UI component factory}.
 *
 * @extends module:core/plugin~Plugin
 */
var ImageUploadUI = /*#__PURE__*/
function (_Plugin) {
    _inherits(ImageUploadUI, _Plugin);
    function ImageUploadUI() {
        _classCallCheck(this, ImageUploadUI);
        return _possibleConstructorReturn(this, _getPrototypeOf(ImageUploadUI).apply(this, arguments));
    }
    _createClass(ImageUploadUI, [{
            key: 'init',
            /**
     * @inheritDoc
     */
            value: function init() {
                var editor = this.editor;
                var t = editor.t;
                // Setup `imageUpload` button.
                editor.ui.componentFactory.add('imageUpload', function (locale) {
                    var view = new FileDialogButtonView(locale);
                    var command = editor.commands.get('imageUpload');
                    var imageTypes = editor.config.get('image.upload.types');
                    var imageTypesRegExp = createImageTypeRegExp(imageTypes);
                    view.set({
                        acceptedType: imageTypes.map(function (type) {
                            return 'image/'.concat(type);
                        }).join(','),
                        allowMultipleFiles: true
                    });
                    view.buttonView.set({
                        label: t('Insert image'),
                        icon: imageIcon,
                        tooltip: true
                    });
                    view.buttonView.bind('isEnabled').to(command);
                    view.on('done', function (evt, files) {
                        var imagesToUpload = Array.from(files).filter(function (file) {
                            return imageTypesRegExp.test(file.type);
                        });
                        if (imagesToUpload.length) {
                            editor.execute('imageUpload', { file: imagesToUpload });
                        }
                    });
                    return view;
                });
            }
        }]);
    return ImageUploadUI;
}(Plugin);
export {
    ImageUploadUI as default
};